export default __webpack_public_path__ + "static/media/google.de8f73b3.png";